import { useEffect, useRef } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function HeadInjector() {
  const { settings } = useSettings();
  const done = useRef(false);

  useEffect(() => {
    if (!settings || done.current) return;

    if (settings.yandex_verification) {
      let el = document.head.querySelector('meta[name="yandex-verification"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "yandex-verification");
        document.head.appendChild(el);
      }
      el.setAttribute("content", settings.yandex_verification);
    }

    if (settings.head_code && !document.getElementById("pp-head-code-marker")) {
      try {
        const frag = document.createRange().createContextualFragment(settings.head_code);
        document.head.appendChild(frag);
        const marker = document.createElement("meta");
        marker.id = "pp-head-code-marker";
        document.head.appendChild(marker);
      } catch (e) {
        console.warn("head_code inject failed", e);
      }
    }
    done.current = true;
  }, [settings]);

  return null;
}
